import "@/commands/appCommands";
import "@/commands/tasks";
import "@/commands/cards";
import "@/commands/graph";
import { TooltipProvider } from "@/ui/Tooltip";
import { AchievementPops } from "@/tasks/AchievementPop";
import { DiscordLinkDialog } from "@/discord/DiscordLinkDialog";
import { VikunjaImportDialog } from "@/vikunja/VikunjaImportDialog";
import { Toasts } from "@/ui/Toasts";
import { AppShell } from "@/shell/AppShell";
import { Palette } from "@/components/Palette";
import { SignInDialog } from "@/components/SignInDialog";
import { HistoryDialog } from "@/components/HistoryDialog";
import { TrashDialog } from "@/components/TrashDialog";
import { ArchiveDialog } from "@/components/ArchiveDialog";
import { ImportDialog } from "@/components/ImportDialog";
import { SettingsDialog } from "@/components/SettingsDialog";
import { TagBrowser } from "@/components/TagBrowser";
import { ShareDialog } from "@/components/ShareDialog";
import { FindReplaceDialog } from "@/components/FindReplaceDialog";
import { ProjectChatDialog } from "@/components/ProjectChatDialog";
import { CreateSharedFolderDialog } from "@/components/CreateSharedFolderDialog";
import { SharedFolderDialog } from "@/components/SharedFolderDialog";
import { TransferConfirmDialog } from "@/components/TransferConfirmDialog";
import { AuthGate, Splash } from "@/components/AuthGate";
import { DocsDialog } from "@/developers/DocsDialog";
import { DevelopersPage } from "@/developers/DevelopersPage";
import { ConnectPage, PENDING_CONNECT_KEY } from "@/developers/ConnectPage";
import { useAuth } from "@/data/auth";
import { isStandalone } from "@/lib/standalone";
import { useShortcuts } from "@/commands/useShortcuts";
import { useBootstrap } from "@/data/boot";

export function App() {
  useShortcuts();
  useBootstrap();
  const status = useAuth((a) => a.status);

  // Server-owned-looking routes that are really ours: the public docs, and
  // the OAuth consent page an assistant sends the user to.
  const path = location.pathname.replace(/\/$/, "");
  if (path === "/developers") {
    return (
      <TooltipProvider>
        <DevelopersPage />
        <Toasts />
      </TooltipProvider>
    );
  }
  if (path === "/connect") {
    return (
      <TooltipProvider>
        <ConnectPage />
        <Toasts />
      </TooltipProvider>
    );
  }
  // a sign-in that started from /connect resumes the consent flow
  if (status === "signedIn") {
    const pending = localStorage.getItem(PENDING_CONNECT_KEY);
    if (pending) {
      localStorage.removeItem(PENDING_CONNECT_KEY);
      location.replace(`/connect?request=${pending}`);
    }
  }

  // Browser tabs are cloud-only: sign in before anything else.
  // Installed (standalone) PWA keeps the anonymous local-first workspace.
  if (!isStandalone() && status !== "signedIn") {
    return (
      <TooltipProvider>
        {status === "loading" ? <Splash /> : <AuthGate />}
        <Toasts />
      </TooltipProvider>
    );
  }

  return (
    <TooltipProvider>
      <AppShell />
      <Palette />
      <SignInDialog />
      <HistoryDialog />
      <TrashDialog />
      <ArchiveDialog />
      <ImportDialog />
      <SettingsDialog />
      <DocsDialog />
      <TagBrowser />
      <ShareDialog />
      <FindReplaceDialog />
      <ProjectChatDialog />
      <CreateSharedFolderDialog />
      <SharedFolderDialog />
      <TransferConfirmDialog />
      <DiscordLinkDialog />
      <VikunjaImportDialog />
      <AchievementPops />
      <Toasts />
    </TooltipProvider>
  );
}
